export enum ETimecardApproveStatus {
    Approve = "approve",
    UnApprove = "unapprove"
}